module.exports = __webpack_public_path__ + "static/media/whitecheckbox.eea0ab54.svg";